/**
 * Picker wrapper around `SolutionsBrowser` - the dialog the exception link editor
 * opens to choose a Freshdesk Solutions article. A row click selects and closes
 * (Cancel-only footer), so there is no confirm step.
 */
import React from 'react'

import BaseDialog from '../dialogs/BaseDialog'
import DialogFooter from '../dialogs/DialogFooter'
import { FreshdeskSolutionArticle } from '../../../services/admin/integrationsApi'
import SolutionsBrowser from './SolutionsBrowser'

interface Props {
  open: boolean
  onClose: () => void
  defaultMarket?: 'ANZ' | 'USA'
  selectedArticleId?: string
  onSelect: (article: FreshdeskSolutionArticle) => void
}

const SolutionsBrowserDialog: React.FC<Props> = ({
  open,
  onClose,
  defaultMarket,
  selectedArticleId,
  onSelect,
}) => (
  <BaseDialog
    open={open}
    onClose={onClose}
    title="Choose a Solutions article"
    size="lg"
    footer={<DialogFooter cancel={{ onClick: onClose }} />}
  >
    <SolutionsBrowser
      mode="picker"
      defaultMarket={defaultMarket}
      selectedArticleId={selectedArticleId}
      onSelect={(article) => {
        onSelect(article)
        onClose()
      }}
    />
  </BaseDialog>
)

export default SolutionsBrowserDialog
